import * as PropTypes from 'prop-types';
import * as React from 'react';
import formatAmount from '../shared/format_amount';

class PriceWithChange extends React.Component {
  get price() {
    let price;

    if (!this.props.bundledPrice) {
      price = this.props.price;
    } else {
      price = this.props.bundledPrice;
    }

    return formatAmount(price);
  }

  get hasDiscount() {
    return (
      this.props.bundledPrice &&
      parseFloat(this.props.bundledPrice.amount) <= parseFloat(this.props.price.amount)
    );
  }

  get originalPrice() {
    if (this.hasDiscount) {
      return (
        <span>
          <strike>{formatAmount(this.props.price)}</strike>{' '}
        </span>
      );
    }
    return null;
  }

  render() {
    return (
      <span>
        {this.originalPrice}
        {this.price}
      </span>
    );
  }
}

PriceWithChange.propTypes = {
  price: PropTypes.object.isRequired,
  bundledPrice: PropTypes.object,
};

export default PriceWithChange;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/price_with_change.jsx